import React, { useEffect, useState } from "react";
import CardComponent from "../cardComponents/CardComponent";
import AccordionComponent from "../accordion/AccordionComponent";
// import { CreditCardData } from './CardData'
import Http from "../../Http";
import { CARD_API } from "../../Helper";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import {
  FaUserCheck,
  FaIdCard,
  FaExternalLinkAlt,
  FaListAlt,
  FaCheckCircle,
  FaFileUpload,
} from "react-icons/fa";
import FAQSchema from "../../FAQSchema";
import { BadgeCheck, FileText } from "lucide-react";
const Standard = () => {
  const [CreditCardData, setCreditCardData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage] = useState(10);
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };
  function Icon({ id, open }) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className={`${
          id === open ? "rotate-180" : ""
        } h-5 w-5 transition-transform`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19.5 8.25l-7.5 7.5-7.5-7.5"
        />
      </svg>
    );
  }

  useEffect(() => {
    Http.post(CARD_API)
      .then((res) => {
        setCreditCardData(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  console.log({ indexOfLastCard, indexOfFirstCard });
  const currentCards = CreditCardData.cards
  ?.filter((card) => card.title?.toLowerCase().includes("standard"))
  .slice(indexOfFirstCard, indexOfLastCard);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const faqs = [
    {
      question: "What is the annual fee for Standard Chartered credit cards?",
      answer:
        " It varies based on the card. Some entry-level cards are lifetime free, while premium options may charge ₹999–₹5,000 annually, often with spend-based waivers.",
    },
    {
      question: "Does Standard Chartered offer airport lounge access?",
      answer:
        "  Yes, select cards like Ultimate and Priority Visa Infinite offer complimentary domestic and international lounge access.",
    },
    {
      question: "Are there any cashback cards from Standard Chartered?",
      answer:
        "  Yes, the Smart Credit Card offers up to 2% cashback on online and retail spends, ideal for daily use.",
    },
    {
      question: "Is the reward program good for travelers?",
      answer:
        "  Yes, several cards allow reward redemption for flight bookings, hotel stays, and travel vouchers through SC’s rewards portal.",
    },
    {
      question:
        "How long does it take to get a Standard Chartered card after applying?",
      answer:
        "  Typically, it takes 7–10 working days after successful document verification and approval.",
    },
  ];

  const steps = [
    {
      icon: <FaCheckCircle className="h-6 w-6 text-orange-500" />,
      title: "Evaluate Eligibility",
      description:
        "   Check your monthly income, credit score, and location to ensure you meet the application criteria before applying.",
    },
    {
      icon: <FaFileUpload className="h-6 w-6 text-green-500" />,
      title: "Prepare Required Documents",
      description:
        " Keep your identity proof, address documents, and income verification papers ready for a smooth process.",
    },
    {
      icon: <FaExternalLinkAlt className="h-6 w-6 text-purple-600" />,
      title: "Redirect to Official SC Portal",
      description:
        "  Once you’ve made your selection, hit “Apply Now” to be taken to Standard Chartered Bank’s official application portal for a secure and complete sign-up experience.",
    },
    {
      icon: <FaListAlt className="h-6 w-6 text-teal-500" />,
      title: "Explore & Compare with TheFinMaster",
      description:
        " Browse through our handpicked selection of Standard Chartered Bank credit cards at TheFinMaster. Each card page is loaded with detailed benefits, annual fee breakdowns, user categories, and unique features—helping you select the card that best aligns with your lifestyle.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>
          Get Standard Chartered Bank Credit Card Offers - Deals &amp; Vouchers
          | TheFinmaster
        </title>
        <meta
          name="description"
          content="Standard Chartered Bank Credit Card Offers - Get Amazon, Flipkart, Paytm, Yatra Shopping, Dining &amp; Easy EMI details, Apparel, Electronics, Grocery, Jewellery, Lifestyle, Travel &amp; more details at TheFinmaster"
        />
        <meta
          name="keywords"
          content="standard chartered credit card payment, sc credit card, scb cc, sc bank cc payment, Get standard and chartered bank credit card"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/standard-bank/credit-card"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      <div className="w-full flex flex-col items-center ">
        <div className="w-full flex flex-col items-center ">
          <div className=" mt-10 w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600">
            <h1 className="text-white text-4xl md:text-7xl text-center font-medium">
              Credit Card
            </h1>
            <p className="text-gray-200 text-lg md:text-2xl pt-2 px-4 text-center">
              Experience financial freedom and flexibility with our credit card
              options.
            </p>
          </div>
        </div>
        <div className="flex justify-center items-center  p-4 ">
          <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-4">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
              Explore a Smart Blend of Rewards, Lifestyle Privileges, and Global
              Utility{" "}
            </h2>

            <p className="text-gray-600 leading-relaxed mt-3">
              Standard Chartered Bank offers a diverse lineup of credit cards
              tailored for smart spenders, travelers, and premium lifestyle
              users. From cashback on everyday purchases to international travel
              benefits and curated dining deals, SC credit cards are known for
              combining practicality with prestige. With global acceptance and
              curated reward programs, Standard Chartered cards suit both
              salaried and business professionals seeking flexible financial
              tools.
            </p>
          </div>
        </div>
        <h1 className="text-center text-2xl md:text-3xl font-bold text-gray-800  my-10">
          Featured Credit Cards
        </h1>
        <div className="w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10">
          <div className="w-fit flex flex-col gap-8">
            {currentCards &&
              currentCards.map((item, index) => {
                return (
                  <>
                    {" "}
                    <CardComponent
                       key={index}
                       cardDetails={item}
                       Card_features={item?.Card_features}
                       fees={item?.fees}
                       cardName={item?.title}
                       cardImage={item?.image}
                       rating={item?.rating}
                       category={item?.category}
                       status={item?.status}
                       bank_link={item?.bank_link}
                    />{" "}
                  </>
                );
              })}
          </div>

         <div className="w-full relative ">
                                      <div className="sticky overflow-hidden top-20 w-full h-[500px] flex flex-col justify-between">
                                        {/* <div className="w-[70%] mx-auto">
                                          <h2 className="text-center font-medium pt-5 text-lg">
                                            <span className="font-semibold text-white">816 people</span>{" "}
                                            are on call with our advisors right now
                                          </h2>
                                        </div> */}
                                        <div className="w-full mx-auto">
                                          <Link to="https://play.google.com/store/apps/details?id=finance.global.travel.niyo&pcampaignid=web_share"     target="_blank"
                              rel="noopener noreferrer">
                                            <div className="w-[80%] mx-auto ">
                                              <img
                                                src="/assets/neoside.png"
                                                alt="Advertisement"
                                             
                                              />
                                            </div>
                                          </Link>
                                          <div className="bg-white">
                                            {/* <h3 className="text-center text-blue-500 cursor-pointer font-semibold py-2">
                                              Know your advisor
                                            </h3> */}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    </div>
        {/* Pagination */}
        <ul className="flex justify-center mt-4">
          {currentCards &&
            CreditCardData.cards?.filter(
              (card) => card.category === "Credit card"
            ).length > 0 &&
            Math.ceil(
              CreditCardData.cards?.filter(
                (card) => card.category === "Credit card"
              ).length / cardsPerPage
            ) > 1 &&
            Array.from({
              length: Math.ceil(
                CreditCardData.cards?.filter(
                  (card) => card.category === "Credit card"
                ).length / cardsPerPage
              ),
            }).map((_, index) => (
              <li key={index} className="mx-1">
                <button
                  className={`px-3 py-1 rounded-lg ${
                    currentPage === index + 1
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-800"
                  }`}
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
        </ul>

 

        {/* <div className='w-[95%] py-10'>
                                         <h1 className='text-center font-bold text-5xl my-10'>Frequently Asked Questions</h1>
                                         <AccordionComponent />
                                     </div> */}

        <div className="w-full px-2 py-2 bg-gradient-to-br from-sky-50 via-white to-sky-100 dark:from-gray-900 dark:to-gray-800">
          <div className="max-w-6xl mx-auto grid gap-10">
            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-sky-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <FileText className="w-8 h-8 text-sky-600" />
                <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                  Eligibility Criteria to Apply for Standard Chartered Credit
                  Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Minimum Age Requirement
                  </span>
                  <span>
                    {" "}
                    Applicants must be at least 21 years old for a primary card
                    and 18 years old for add-on cards.{" "}
                  </span>
                </div>

                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Minimum Income
                  </span>
                  <span>
                    {" "}
                    A monthly income of ₹25,000 or more is required. Premium
                    cards like Ultimate may need higher income thresholds.
                  </span>{" "}
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Credit Score
                  </span>
                  <span>
                    {" "}
                    A CIBIL score of 750+ is highly recommended. Applicants with
                    a strong credit repayment history are preferred.{" "}
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Location
                  </span>
                  <span>
                    {" "}
                    SC credit cards are issued in selected cities and PIN codes.
                    Applicants should ensure their residential or work location
                    is serviceable.{" "}
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Employment Type
                  </span>
                  <span>
                    {" "}
                    Both salaried professionals and self-employed individuals
                    are eligible, provided their income is stable and
                    well-documented.
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-emerald-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <BadgeCheck className="w-8 h-8 text-emerald-600" />
                <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                  Documents Required to Apply for Standard Chartered Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Identity
                  </span>
                  <span>
                    {" "}
                    Submit any valid government-issued photo ID such as Aadhaar
                    Card, PAN Card, Passport, or Driving License.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Address
                  </span>
                  <span>
                    {" "}
                    Recent utility bills, rental agreements, Aadhaar, or
                    passport can be submitted as residential address proof.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Income Documents
                  </span>
                  <span>
                    {" "}
                    Salaried: Last 3 months’ salary slips or Form 16.
                    Self-Employed: Last 2 years’ ITRs, audited financials, and
                    bank statements
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Photograph
                  </span>
                  <span>
                    {" "}
                    A recent passport-sized color photograph is typically
                    required for offline verification.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl sm:col-span-2">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    PAN Card
                  </span>
                  <span>
                    {" "}
                    Mandatory for income tax and financial identification
                    purposes. Applications without a valid PAN are rejected.{" "}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-4 py-10 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-4">
        How to Apply for Standard Chartered Credit Card
        </h2>
        {/* <p className="text-gray-600 text-sm md:text-base mt-2 text-center mb-8">
                                   Applying for a fuel credit card is a seamless process that starts with
                                   the right research and ends at the official bank’s platform for final
                                   submission. Here’s how you can get started through TheFinMaster.com:
                                 </p> */}
        <div className="grid gap-6 md:grid-cols-2">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex items-start gap-4 p-4 rounded-xl bg-white dark:bg-gray-900 shadow-md border hover:shadow-lg transition"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="mt-1">{step.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{`${
                  index + 1
                }. ${step.title}`}</h3>
                <p className="text-md text-gray-600 dark:text-gray-300">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="max-w-4xl mx-auto py-6 px-2">
        <h1 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h1>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Standard;

// import React, { useEffect, useState } from 'react'
// import CardComponent from '../cardComponents/CardComponent'
// import AccordionComponent from '../accordion/AccordionComponent'
// // import { CreditCardData } from './CardData'
// import Http from '../../Http'
// import { CARD_API } from '../../Helper'
// import { Link } from 'react-router-dom'
// import { Helmet } from 'react-helmet'
// const Standard = () => {
//     const [CreditCardData,setCreditCardData] = useState([])
//     const [currentPage, setCurrentPage] = useState(1);
//     const [cardsPerPage] = useState(10);

//     useEffect(()=>{
//         Http.post(CARD_API).then((res)=>{
//             setCreditCardData(res)
//         }).catch((err)=>{
//             console.log(err)
//         })
//     },[])
//     const indexOfLastCard = currentPage * cardsPerPage;
//     const indexOfFirstCard = indexOfLastCard - cardsPerPage;
//     console.log({indexOfLastCard,indexOfFirstCard})
//     const currentCards = CreditCardData.cards?.filter((card)=>card.category==="Credit card").slice(indexOfFirstCard, indexOfLastCard);
//     console.log({currentCards})

//     const paginate = (pageNumber) => setCurrentPage(pageNumber);

//     return (
//         <>
//     <Helmet>
//     <title>Get Standard Chartered Bank Credit Card Offers - Deals &amp; Vouchers | TheFinmaster</title>
//    <meta  name='description' content='Standard Chartered Bank Credit Card Offers - Get Amazon, Flipkart, Paytm, Yatra Shopping, Dining &amp; Easy EMI details, Apparel, Electronics, Grocery, Jewellery, Lifestyle, Travel &amp; more details at TheFinmaster'/>
//    <meta name='keywords' content='standard chartered credit card payment, sc credit card, scb cc, sc bank cc payment, Get standard and chartered bank credit card' />
//    <link rel="canonical" href="https://thefinmaster.com/standard-bank/credit-card" />
//    <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
//    <meta name="robots" content="max-video-preview:-1" />
//  </Helmet>
//         <div className='w-full flex flex-col items-center '>

//             <div className='w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600'>
//                 <h1 className='text-white md:text-7xl text-centerz-20 font-medium'>
//                     Credit Card
//                 </h1>
//                 <p className='text-gray-200 text-2xl pt-2'>Experience financial freedom and flexibility with our credit card options.</p>
//                 {/* <img className='w-[100%] h-[100%] object-cover' src='https://www.kotak.com/content/dam/Kotak/guidance/hero-slider-banner/hacks-for-being-regular-with-personal-loan-repayments-hero-desktop.jpg' alt='personalLoan' /> */}

//             </div>

//             <h1 className='text-center font-bold text-5xl my-10'>Featured Credit Cards</h1>
//             <div className='w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10'>
//                 <div className='w-fit flex flex-col gap-8'>
//                     {
//                         currentCards &&
//                         currentCards.map((item, index) => {
//                             return <> <CardComponent key={index} Card_features={item?.Card_features} fees={item?.fees} cardName={item?.title} cardImage={item?.image} rating={item?.rating} category={item?.category} status={item?.status} /> </>
//                         })
//                     }
//                 </div>

//                 <div className='w-full relative '>
//                     <div className='sticky overflow-hidden top-20 shadow-lg w-full h-[230px] rounded-2xl bg-blue-500 border flex flex-col justify-between'>
//                         <div className='w-[70%] mx-auto'>
//                             <h2 className='text-center font-medium pt-5 text-lg'><span className='font-semibold text-white'>816 people</span> are on call with our advisors right now</h2>
//                         </div>
//                         <div className='w-full mx-auto'>
//                             <div className='w-[70%] mx-auto'>
//                                 <img src='https://static.pbcdn.in/health-cdn/images/insurer-logo/quotes-logos/advisors-logo.png' alt='imgg' />
//                             </div>
//                             <div className='bg-white'>
//                                 <h3 className='text-center text-blue-500 cursor-pointer font-semibold py-2'>Know your advisor</h3>
//                             </div>
//                         </div>
//                     </div>

//                 </div>

//             </div>
//                    {/* Pagination */}
//                    <ul className='flex justify-center mt-4'>
//                 {currentCards &&
//                      CreditCardData.cards?.filter((card)=>card.category==="Credit card").length > 0 &&
//                     Math.ceil( CreditCardData.cards?.filter((card)=>card.category==="Credit card").length / cardsPerPage) > 1 &&
//                     Array.from({ length: Math.ceil( CreditCardData.cards?.filter((card)=>card.category==="Credit card").length / cardsPerPage) }).map((_, index) => (
//                         <li key={index} className='mx-1'>
//                             <button
//                                 className={`px-3 py-1 rounded-lg ${
//                                     currentPage === index + 1 ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-800'
//                                 }`}
//                                 onClick={() => paginate(index + 1)}
//                             >
//                                 {index + 1}
//                             </button>
//                         </li>
//                     ))}
//             </ul>

//             <div className='w-[95%] py-10'>
//                 <h1 className='text-center font-bold text-5xl my-10'>Frequently Asked Questions</h1>
//                 <AccordionComponent />
//             </div>
//         </div>
//         </>
//     )
// }

// export default Standard
